import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  input,
  InputSignal,
  Renderer2,
} from '@angular/core';
import {
  ToastComponent,
  ToasterService,
  ToastCloseDirective,
} from '@coreui/angular';

@Component({
  selector: 'app-notification',
  standalone: true,
  providers: [
    {
      provide: ToastComponent,
      useExisting: forwardRef(() => NotificationComponent),
    },
  ],
  imports: [CommonModule, ToastCloseDirective],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent extends ToastComponent {
  @Input({ required: true }) title!: string;

  @Input({ required: true }) type!: string;

  @Input() message!: string;

  constructor(
    public override hostElement: ElementRef,
    public override renderer: Renderer2,
    public override toasterService: ToasterService,
    public override changeDetectorRef: ChangeDetectorRef,
  ) {
    super(hostElement, renderer, toasterService, changeDetectorRef);
  }
}
